module.exports = __webpack_public_path__ + "static/media/summary-publish.54412e72.svg";